var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'便利機能'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'睡眠目標の設定変更による影響について',"urlName":'Help27'}}),_vm._v(" "),_c('list-item',{attrs:{"spanText":'Q. ',"text":'WeBandの天気情報は現在の天気と異なる原因',"urlName":'Help20'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05beec52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory36.vue
// module id = WDff
// module chunks = 0